import { TAction, TActionType, TState } from "../types/ReducerType";

export const stateReducer = (state: TState, action: TAction): TState => {
  switch (action.type) {
    case TActionType.IsShowingConfirmButton:
      return {
        ...state,
        isShowingConfirmButton: action.payload,
      };
    case TActionType.IsShowingInstallmentAmountError:
      return {
        ...state,
        isShowingInstallmentAmountError: action.payload,
      };
    case TActionType.TableData:
      return {
        ...state,
        table: action.payload,
      };
    case TActionType.Filter:
      return {
        ...state,
        filter: action.payload,
      };
    default:
      throw new Error();
  }
};